import React from 'react';

export type LogLevel = 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';

const logColorMapping: Record<LogLevel, string> = {
  DEBUG: 'white',
  INFO: 'green',
  WARN: 'yellow',
  ERROR: 'red',
};

interface LogProps {
  time: string;
  level: LogLevel;
  message: string;
}

const Log = ({ time, level, message }: LogProps) => {
  const textColor = logColorMapping[level];
  return (
    <div style={{ color: textColor }}>
      {time} {level}: {message}
    </div>
  );
};

export default Log;
